
import HierarchySquare3 from "../../../assets/duotone/HierarchySquare3.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function HierarchySquare3Icon({ className, dataTestid = "HierarchySquare3Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <HierarchySquare3 data-testid={dataTestid} className={classes} {...rest} />
  );
}
